import { useRef } from 'react';

/**
 * Verrou de premier montage pour un panneau de régie : renvoie `true` dès la première ouverture,
 * puis reste `true`. Replier le panneau doit le masquer en CSS, pas le démonter, sinon son contenu
 * est rechargé à chaque réouverture. À réserver aux panneaux dont l'état ne dépend pas de ce qui
 * s'est passé avant leur première ouverture : ceux qui écoutent Ably doivent être montés d'emblée.
 */
export function useKeepMountedOnce(isOpen: boolean): boolean {
  const hasOpenedRef = useRef(false);
  if (isOpen) hasOpenedRef.current = true;
  return hasOpenedRef.current;
}
